import { useEchoNotification } from '@laravel/echo-vue'

import { mapNotificationFromReverb } from '@/helpers/notification-helper'

import { useAuthorizationStore } from '@/store/authorizationStore'
import { useNotificationsStore } from '@/store/notificaitonsStore'

import { ECHO_CHANNELS } from '@/constants/echoChannels'

const notificationSound = new Audio('/notification-sound.mp3')

export function useUserNotifications() {
    const authorizationStore = useAuthorizationStore()
    const notificationsStore = useNotificationsStore()

    if (!authorizationStore.getUserId) {
        return
    }

    useEchoNotification(
        ECHO_CHANNELS.userNotifications(),
        (notification) => {
            notificationsStore.addNotification(mapNotificationFromReverb(notification))

            notificationSound.currentTime = 0
            notificationSound.play().catch(() => {})
        },
    )
}
